import { Component, Element, Prop, h, Host, EventEmitter, Event } from '@stencil/core';

/**
 * @deprecated This component will be removed in v8. Please use the `pn-tablist` instead.
 * @see {@link https://portal.postnord.com/web-components/?path=/docs/components-navigation-tablist--docs} Use `pn-tablist` instead.
 */
@Component({
  tag: 'pn-page-nav-item',
  styleUrl: 'pn-page-nav-item.scss',
})
export class PnPageNavItem {
  @Element() hostElement: HTMLElement;

  /** The item value. Used by `pn-page-nav` to determine pre-selected item. */
  @Prop() value!: string;
  /** Pass an href to the items if you want to have links that lead outside of your app. */
  @Prop() href: string;
  /** The SVG content of the icon you want. */
  @Prop() icon: string;

  /** Event is emitted when you select an item. */
  @Event() itemselection: EventEmitter<string>;

  select(e: MouseEvent) {
    if (this.value && !this.href) e.preventDefault();

    this.itemselection.emit(this.value);
  }

  render() {
    return (
      <Host>
        <li>
          <a href={this.href || '#'} class="pn-page-nav-item" onClick={e => this.select(e)}>
            {this.icon && <pn-icon icon={this.icon} color="white"></pn-icon>}
            <slot></slot>
          </a>
        </li>
      </Host>
    );
  }
}
